import * as actions from './redux/actions';
import * as constants from './redux/constants';
import reducer from './redux/reducer';

import MainNavigationContainer from './containers/MainNavigationContainer';

export { actions, constants, reducer };
export default MainNavigationContainer;
